export const GET_ERRORS = "GET_ERRORS";
export const TEACHER_LOADING = "TEACHER_LOADING";
export const SET_CURRENT_TEACHER = "SET_CURRENT_TEACHER";
export const SET_USED_CODE = "SET_USED_CODE";
export const VALID_RESET_TOKEN = "VALID_RESET_TOKEN";
export const IS_EDITING = "IS_EDITING";
export const SUCCESS = "SUCCESS";